import { Component, Input, OnInit } from '@angular/core';
import { VehicleListService } from 'src/app/services/vehiclelist.service';
import { AuctionInfoComponent } from '../auction-info/auction-info.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AlertService } from 'src/app/services/alert.service';
import { BidderService } from 'src/app/services/bidder.service';
import { Router } from '@angular/router';
import { Global } from 'src/app/shared/global';
import { SearchModel } from 'src/app/models/search';
@Component({
    selector: 'app-vehicle-card-list',
    templateUrl: './vehicle-card-list.component.html',
    styleUrls: ['./vehicle-card-list.component.css'],
    standalone: false
})
export class VehicleCardListComponent implements OnInit {

  @Input() auctionDateId: any;
  @Input() pageSize: any;
  @Input() pageNum: any;
  @Input() enterpriseId: any;
  @Input() makeId: any;
  @Input() modelId: any;
  @Input() styleId: any;
  @Input() fromYear: any;
  @Input() toYear: any;
  @Input() storageLotId: any;
  @Input() colorId: any;

  public auctionInfoModalRef: BsModalRef;

  PageList = [];
  TotalPagenum: number;
  PageId: number;

  userId: number;
  bidderId: any = '';
  currentUser: any;
  roleName: string;
  groupName: string;

  view: string = 'cards';
  
  vehicleList = [];

  imageLoader = true;
  noImageUrl: any = Global.NoImageUrl;

  constructor(
    private vehicleListService: VehicleListService,
    private modalService: BsModalService,
    private alertService: AlertService,
    private _bidderService: BidderService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    if (this.currentUser) {
      this.roleName = this.currentUser.rolename;
      this.groupName = this.currentUser.groupname;
      this.userId = this.currentUser.userid;
      this.bidderId = this.currentUser.bidderid;
    } else {
      this.roleName = 'Guest';
    }

    this.getLatesVehicles();
  }

  getLatesVehicles(){
    let searchModel: SearchModel = new SearchModel();
    searchModel.enterprise = this.enterpriseId;
    searchModel.yearFrom= this.fromYear;
    searchModel.yearTo = this.toYear ;
    searchModel.make = this.makeId ;
    searchModel.model = this.modelId ;
    searchModel.color = this.colorId;
    searchModel.style = this.styleId;
    searchModel.auctionDateId = this.auctionDateId;
    searchModel.storageLotId = this.storageLotId;
    searchModel.iscurrentAuction = false;
    this.vehicleListService.searchAuctionVehicle(searchModel, this.bidderId, this.pageNum, this.pageSize).subscribe((data) => {
      this.vehicleList = data;//data['Vehicles'];
    });
  }

  toggleView(view: string) {
    this.view = view;
  }

  OpenAuctionInfoModal(productId) {
    this.auctionInfoModalRef = this.modalService.show(AuctionInfoComponent, { class: 'gray modal-xl', backdrop: 'static',      initialState: {
      //  productId: productId,
      }});
    this.auctionInfoModalRef.content.closeModal.subscribe(() => {
      this.auctionInfoModalRef.hide();
    });
  }

  
  previous() {
    if (this.PageId) {
      if (this.PageId > 1) {
        this.pageNum = this.PageId - 1;
        this.PageId = this.pageNum;
        this.getLatesVehicles();
      }
    }
  }

  next() {
    if (this.PageId) {
      if (this.PageId < this.TotalPagenum) {
        this.pageNum = this.PageId + 1;
        this.PageId = this.pageNum;
        this.getLatesVehicles();
      }
    }
  }

  onPageChange(PageNumber: any) {    
    this.pageNum = PageNumber;
    this.PageId = PageNumber;
    this.getLatesVehicles();
  }

  addToFavorite(item, index) {
    if (!this.currentUser && this.roleName == 'Guest') {
      this.router.navigate(['login'], {
        queryParams: { returnUrl: 'searchdetails' },
        state: {
          enterpriseId: this.enterpriseId,
          makeId: this.makeId,
          modelId: this.modelId,
          styleId: this.styleId,
          colorId: this.colorId,
          fromYear: this.fromYear,
          toYear: this.toYear,
          adateId: '',
          iscurrent: ''
        }
      });
      return;
    }
    else {
      this._bidderService.saveProductFavorite(item.ProductId, this.bidderId).subscribe(data => {
        switch (data['id']) {
          case -1:
            this.alertService.showError(data['result']);
            break;
          default:
            this.alertService.showSuccess(data['result']);
            let filteredData = this.vehicleList[index];
            this.vehicleList[index].FavProductId = item.ProductId;
            break;
        }
      },
        error => {
          this.alertService.showError(error);
        });
    }
  }

  removeFavorite(item, index) {
    if (!this.currentUser && this.roleName == 'Guest') {
      this.router.navigate(['login'], {
        queryParams: { returnUrl: 'searchdetails' },
        state: {
          enterpriseId: this.enterpriseId,
          makeId: this.makeId,
          modelId: this.modelId,
          styleId: this.styleId,
          colorId: this.colorId,
          fromYear: this.fromYear,
          toYear: this.toYear,
          adateId: '',
          storageLotId: this.storageLotId,
          iscurrent: false
        }
      });
      return;
    }
    else {
      this._bidderService.removeProductFavorite(item.ProductId, this.bidderId).subscribe(data => {
        switch (data['id']) {
          case -1:
            this.alertService.showError(data['result']);
            break;
          default:
            this.alertService.showSuccess(data['result']);
            let filteredData = this.vehicleList[index];
            this.vehicleList[index].FavProductId = 0;
            break;
        }
      },
        error => {
          this.alertService.showError(error);
        });
    }
  }

  navigate(item) {
    this.router.navigate(['vehicledetails', item.ProductId], {
      state: {
        pid: item.ProductId
      }
    });
  }

  getImage(images: any[]): any {   
    if (images?.length > 0) {
      return images[0].base64Image;
    } else {
      return Global.NoImageUrl;
    }
  }


}
